import styled from "@emotion/styled";
import type { PublicKey } from "@solana/web3.js";
import { formatBalance, transparentWhite } from "@stepfinance/react";
import type { FC, MouseEvent } from "react";

import { useLanguageContext } from "../../contexts/language/language";
import { useAccountByMint } from "../../hooks";

interface UserMintBalanceProps {
  disabled?: boolean;
  mint?: PublicKey | string;
  balance?: number;
  onClick?: (event?: MouseEvent<HTMLElement, globalThis.MouseEvent>) => void;
}

export const UserMintBalance: FC<UserMintBalanceProps> = ({ mint, onClick, disabled, balance }) => {
  const account = useAccountByMint(mint);
  const userBalance = account ? account.tokenAmount.uiAmount : balance ? balance : 0;
  const decimals = account ? account.tokenAmount.decimals : undefined;
  const {
    currentLanguageData: { common },
  } = useLanguageContext();

  return (
    <>
      <BalanceSpan disabled={disabled} onClick={onClick} selectable={!!onClick}>
        <span>{common.balance}: </span>
        <BalanceAmountText selectable={!!onClick}>{formatBalance(userBalance, decimals)}</BalanceAmountText>
      </BalanceSpan>
    </>
  );
};

export const BalanceInfoDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const BalanceSpan = styled.span<{ disabled?: boolean; selectable: boolean }>`
  display: inline;
  cursor: ${({ disabled, selectable }) => (selectable ? (disabled ? "not-allowed" : "pointer") : "default")};
  user-select: ${({ disabled }) => (disabled ? "none" : undefined)};
  color: ${transparentWhite};
  font-size: 14px;
  line-height: 22px;
`;

export const BalanceAmountText = styled.span<{ selectable?: boolean | undefined }>`
  text-decoration-line: ${({ selectable }) =>
    selectable === undefined || selectable === true ? "underline" : undefined};
  font-family: Space Mono;
`;
